import { useEffect, useState } from 'react';

interface Props {
  ateMs: number;
  duracaoMs: number;
  rotulo: string;
}

/** Barra de fabricação. A duração vem do servidor; o cliente só desenha. */
export function CraftBar({ ateMs, duracaoMs, rotulo }: Props) {
  const [, pulse] = useState(0);
  useEffect(() => {
    let raf = 0;
    const tick = () => {
      if (performance.now() >= ateMs) return;
      pulse(n => n + 1);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [ateMs]);
  const remaining = Math.max(0, ateMs - performance.now());
  const frac = duracaoMs > 0 ? Math.min(1, (duracaoMs - remaining) / duracaoMs) : 1;
  const pct = Math.round(frac * 100);
  return (
    <div className="craft-bar">
      <p className="smith-skill">{rotulo}</p>
      <div
        className="bar-mini"
        role="progressbar"
        aria-label={rotulo}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
      >
        <i style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
